import { GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { VisitLookup } from "./visits.lookup";

export class Visit {
    Id: number;
    Name: string;
    OrderBy: number;

    constructor(id: number, name: string, ordering: number) { this.Id = id; this.Name = name; this.OrderBy = ordering; }
}


export class VisitEvent {

    private static THIRTY_DAYS_MS: number = 2592000000;

    StudyId: number;
    SiteNumber: number;
    AppendixId: number;
    VisitId: number;
    VisitStatusId: number;
    DaysFromWindow: number;
    DaysFromWindowId: number;
    RequiredId: number;
    SubjectId: string;
    VisitDateStr: string;
    VisitLowerDateStr: string;
    VisitUpperDateStr: string;
    TargetDateStr: string;

    initialize(): void {
        let absDaysFromWindow = Math.abs(this.DaysFromWindow);
        if (absDaysFromWindow == 0) { this.DaysFromWindowId = 20;  } //in window
        else if (absDaysFromWindow <= 3) { this.DaysFromWindowId = 21; } //1 to 3
        else if (absDaysFromWindow <= 7) { this.DaysFromWindowId = 22; } //4 to 7
        else if (absDaysFromWindow <= 14) { this.DaysFromWindowId = 23; } // 8 to 14
        else if (absDaysFromWindow >= 15) { this.DaysFromWindowId = 24; } //15+
        
        if (this.VisitStatusId == 2) { //not yet due
            let targetDate: Date = GetDateFromString(this.TargetDateStr, "slash-month-day-year");

            let timeDelta: number = Math.abs(targetDate.getTime() - Date.now());
            if (timeDelta <= VisitEvent.THIRTY_DAYS_MS) { this.VisitStatusId = 6; }
            else { this.VisitStatusId = 7; }
        }
    }

}
